<template>
  <div>
    <v-main v-resize="onResize">
      <v-navigation-drawer
        app
        left
        color="white"
        fixed
        floating
        :width="480"
        :value="windowSize.x > 1080 || navigationModel"
        disable-route-watcher
        clipped
        :temporary="windowSize.x < 1080"
        mobile-breakpoint="1080"
      >
        <Sidebar app />
      </v-navigation-drawer>
      <v-app-bar
        app
        clipped-left
        :elevate-on-scroll="windowSize.x < 1080"
        :shrink-on-scroll="windowSize.x < 1080"
        :flat="windowSize.x > 1080 || navigationModel"
        fixed
        tile
        top
        style="z-index: 7"
        :height="windowSize.x > 1080 ? '195' : '140'"
        :collapse="windowSize.x > 1080"
        :min-width="windowSize.x > 1080 ? '480' : '320'"
        min-height="95"
        color="white"
      >
        <v-sheet
          color="transparent"
          :height="windowSize.x > 1080 ? '315' : '100%'"
          min-height="70"
          width="100%"
          class="app-logo d-flex flex-column justify-end"
        >
          <router-link :to="{ name: 'home' }" style="display: block">
            <v-img
              src="logo_rtb.svg"
              class="logo"
              width="99px"
              height="12px"
              contain
              @click="category.activeCategories = []"
            />
          </router-link>
          <div class="page-title">
            <div @click="$router.push({ name: 'home' })">
              <div>BANNERS</div>
              <div>PORTFOLIO</div>
              <div class="concept">CONCEPT DESIGN</div>
            </div>

            <v-spacer></v-spacer>
            <v-app-bar-nav-icon
              color="primary"
              x-large
              right
              class="hamburger"
              transition="fade-transition"
              @click.stop="navigationModel = !navigationModel"
            />
          </div>
        </v-sheet>
      </v-app-bar>
      <v-container fluid class="py-0">
        <v-row justify="center">
          <v-col class="banners py-0" cols="12">
            <!-- <slot /> -->
            <transition :name="transitionName" mode="out-in">
              <keep-alive include="BannersHome">
                <router-view />
              </keep-alive>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <div class="text-center">

    </div>
    <!-- <v-snackbar
      v-for="(snackbar, index) in snackbar.snackbars.filter((s) => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      right
      tile
      :style="`bottom: ${index * 60 + 8}px`"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" @click="snackbar.showing = false" text>
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar> -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      transitionName: "slide-right",
      navigationModel: null,
      windowSize: {
        x: 0,
        y: 0,
      },
      offsetTop: 0,
    };
  },
  created() {
    this.fetchBanners();
  },
  components: {
    Sidebar: () => import("@/components/Sidebar"),
  },
  computed: {
    ...mapGetters(["role", "displayRole", "viewID"]),
    ...mapState(["snackbar", "category"]),
  },
  methods: {
    ...mapActions(["fetchBanners"]),
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      if (this.windowSize.x > 1080) this.navigationModel = false;
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;
      this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
    },
  },
};
</script>
<style lang="scss" scoped>
.concept {
  width: 95px;
  height: 21px;
  line-height: 21px;
  color: #ffffff;
  background-color: #ef3f37;
  font-size: 10px;
  text-align: center;
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 6px;
}
.custom-navigation {
  top: 120px;
}
.banners {
  display: flex;
  flex-wrap: wrap;
  transition: padding 200ms 500ms ease;
  min-height: 100vh;
  margin: 0;
}
.app-logo {
  padding: 0 64px;
}
.logo {
  margin-top: 90px;
  transition: margin 200ms;
}
.page-title {
  position: relative;
  margin: 56px 0 85px;
  transition: margin 200ms 500ms;
  div {
    cursor: pointer;
  }
  div > :nth-child(1) {
    line-height: 1;
    font-size: 30px;
    font-weight: 700;
    letter-spacing: -1px;
    margin-bottom: 5px;

    transition: font-size 200ms;
  }
  div > :nth-child(2) {
    transition: font-size 200ms 500ms;
    letter-spacing: -1px;
    transform: translateX(-2px);
    line-height: 0.7;
    color: #ef3f37;
    font-size: 55px;
    font-weight: 100;
    font-style: normal;
    transition: font-size 200ms;
  }
}

.invalid-token {
  width: 100vw;
  height: 50vh;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.transitiontest-enter-active,
.transitiontest-leave-active {
  transition: opacity 0.1s, transform 0.1s;
}
.transitiontest-enter, .transitiontest-leave-to /* .transitiontest-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0.99);
}

.banner {
  display: flex;
  align-items: center;
  transition: all 0.25s;
}

.banners-enter,
.banners-leave-to {
  opacity: 0;
  transform: scale(0.8);
  z-index: 0;
}
.banners-leave-active {
  position: absolute !important;
}
.banners-move {
  transition: all 0.2s;
  z-index: 0;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  transition-property: opacity, transform;
  transition-duration: 100ms;
}

.slide-right-enter-active,
.slide-left-enter-active {
  transition-delay: 0ms;
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translateX(-10px);
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translateX(10px);
}
.hamburger {
  display: none;
  pointer-events: none;
  transition: opacity 0ms;
  opacity: 0;
}
@media only screen and (max-width: 1080px) {
  .app-logo {
    justify-content: center !important;
  }
  .concept {
    left: 0;
    margin-top: -11px;
  }
  .logo {
    margin-top: 0;
  }
  .page-title {
    transition: margin 200ms;
    margin: 0;
    display: flex;
    align-items: center;
    & > div {
      display: flex;
      align-items: center;
    }
    div > :nth-child(1) {
      margin-bottom: 0;
      font-size: 1.2em;
    }
    div > :nth-child(2) {
      margin: 0 0.25em;
      font-size: 1.2em;
    }
  }
  .hamburger {
    display: inline-block;
    opacity: 1;
    pointer-events: all;
    transition: opacity 200ms;
  }
  .banners {
    padding: 60px 20px 90px;
    transition: padding 200ms;
  }
}
@media (max-width: 750px) {
  .app-logo {
    padding: 0;
  }
  .page-title {
    div {
      font-size: 1em !important;
    }
    & > span {
      display: none;
    }
    .concept {
      left: 0;
      font-size: 10px !important;
      margin-top: -13px;
    }
  }
  .banners {
    padding: 0;
  }
}
</style>
